
















































import {
  computed, defineComponent, reactive, watch,
} from '@vue/composition-api';

import { useRouter } from 'vivat';

import getComponent from '@/gql/getComponent.gql';
import createComponent from '@/gql/createComponent.gql';
import updateComponent from '@/gql/updateComponent.gql';

import PanelWithFileInput from '@/components/Component/PanelWithFileInput.vue';
import PanelWithTagsEditor from '@/components/Component/PanelWithTagsEditor.vue';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';

const PageColumnWithComponentEditor = defineComponent({
  components: {
    PanelWithFileInput,
    PanelWithTagsEditor,
  },
  props: {
    id: {
      type: String,
      required: false,
    },
  },
  setup(props) {
    const form = reactive({
      name: '',
      description: '',
      font: '',
      designer: '',
      note: '',
      images: [],
      files: [],
      tags: [],
    });

    const { result: getComponentResult } = useQuery(getComponent, () => ({ id: props.id }));
    const component = useResult(getComponentResult, null, (data: any) => data.component);

    watch(component, () => {
      if (!component.value) return;
      form.name = (component.value as any).name;
      form.description = (component.value as any).description;
      form.font = (component.value as any).font;
      form.designer = (component.value as any).designer;
      form.note = (component.value as any).note;
      form.images = (component.value as any).images.map((img: any) => img.id);
      form.files = (component.value as any).files.map((file: any) => file.id);
      form.tags = (component.value as any).tags.map((tag: any) => tag.name);
    });

    const { router } = useRouter();
    const isEditing = computed(() => !!props.id);

    const createComponentMutation = useMutation(createComponent, () => ({
      variables: {
        input: { ...form },
      },
      refetchQueries: ['getComponents'],
    }));

    const updateComponentMutation = useMutation(updateComponent, () => ({
      variables: {
        id: props.id,
        input: { ...form },
      },
    }));

    const mutation = computed(() => {
      if (isEditing.value) return updateComponentMutation;
      return createComponentMutation;
    });

    return {
      form,
      isEditing,
      mutation,
    };
  },
});

export default PageColumnWithComponentEditor;
